/**
 * Sort Bar Module
 * - Combo select for sort field + asc/desc direction buttons
 * - Reads current sort from URL, navigates on change
 */

export function initSortBar() {
  var bar = document.querySelector('.sort-bar');
  if (!bar) return;

  var select = bar.querySelector('.sort-bar__select');
  var baseUri = bar.getAttribute('data-base-uri');
  var btnAsc = bar.querySelector('.sort-bar__dir-btn--asc');
  var btnDesc = bar.querySelector('.sort-bar__dir-btn--desc');

  if (!select || !btnAsc || !btnDesc) return;

  // Detect current sort from URL
  var match = window.location.href.match(/orderType=(\w+)_(asc|desc)/);
  var currentDir = 'asc';

  if (match) {
    // Set selected option
    var opts = select.options;
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].value === match[1]) {
        select.selectedIndex = i;
        break;
      }
    }
    currentDir = match[2];
  }

  // Set active direction button
  if (currentDir === 'desc') {
    btnDesc.classList.add('is-active');
  } else {
    btnAsc.classList.add('is-active');
  }

  function navigate() {
    var field = select.value;
    var dir = btnDesc.classList.contains('is-active') ? 'desc' : 'asc';
    window.location.href = baseUri + ';orderType=' + field + '_' + dir;
  }

  select.addEventListener('change', navigate);

  btnAsc.addEventListener('click', function() {
    if (btnAsc.classList.contains('is-active')) return;
    btnAsc.classList.add('is-active');
    btnDesc.classList.remove('is-active');
    navigate();
  });

  btnDesc.addEventListener('click', function() {
    if (btnDesc.classList.contains('is-active')) return;
    btnDesc.classList.add('is-active');
    btnAsc.classList.remove('is-active');
    navigate();
  });
}
